import '@material/elevation/dist/mdc.elevation.css';
import { Elevation as E } from '@rmwc/elevation';

export const Elevation = E;
export default Elevation;
